module.exports = __webpack_public_path__ + "media/images/vod-bg-33bce63743f83cfe32f212df4e35e42d.jpg";